import { Form } from '@app/components/common/form/form';
import { useAlert, useApi, useAutocomplete, useEntityState } from '@app/hooks';
import { AutocompleteField, SwitchField, TextField, Txt } from '@app/components/common';
import { QueryTable } from '@app/components/common/table';
import { Employee } from '@app/api/models/structure';

import { EmployeeLinksTable } from './employee-links-table';

type EmployeesFormProps = {
  initial?: Employee;
  onSubmit?(instance: Partial<Employee>): Promise<void>;
  onCancel?(): void;
};

export const EmployeesForm = ({
  initial,
  onSubmit,
  onCancel,
}: EmployeesFormProps) => {
  const { info } = useAlert();
  const api = useApi();
  const [instance, onChange] = useEntityState<Employee>(initial);
  const getAutocomplete = useAutocomplete();
  const { refetch } = QueryTable.useQueryTable();

  const onSubmitForm = async (instance: Partial<Employee>) => {
    let response;
    if (initial) {
      response = await api.structure.updateEmployee({
        id: instance.id,
        name: instance.name,
        user_id: instance.user?.id || null,
        is_active: instance.is_active,
      });
    } else {
      response = await api.structure.createEmployee({
        name: instance.name,
        user_id: instance.user?.id,
      });
    }
    if (response?.code === 200) {
      await refetch();
      info(response.message);
      onSubmit(instance);
    }
  };

  return <Form
    instance={instance}
    onSubmit={onSubmitForm}
    onCancel={onCancel}
    onChange={onChange}
  >
    <Form.Item
      label="ФИО"
      field='name'
      required
      component={TextField}
      span={{ md: 12 }}
    />
    <Form.Item
      label="Пользователь"
      field='user'
      component={AutocompleteField}
      componentProps={{
        name: 'user',
        valueProperty: 'full_name',
        onFetchOptions: getAutocomplete,
      }}
      span={{ md: 12 }}
    />
    <Form.Item
      label="Комментарий"
      field='comment'
      component={TextField}
      span={{ md: 12 }}
      componentProps={{ multiline: true }}
    />
    {initial && <Form.Item
      label="Активность"
      field='is_active'
      component={SwitchField}
      span={{ md: 12 }}
    />}
    {initial?.id ? (
      <Form.Spacer span={{ md: 12 }}>
        <EmployeeLinksTable employeeId={Number(initial.id)} />
      </Form.Spacer>
    ) : (
      <Form.Spacer span={{ md: 12 }}>
        <Txt color="gray.500">
          Привязки к коду ТА будут доступны после создания сотрудника
        </Txt>
      </Form.Spacer>
    )}
  </Form>;
};
